import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ActivityLog, Cell, Duty } from '../backend/backendapi';
import { formatDateTime } from '../../util';
import TodoList from '../todolist/TodoList';

@Component({
    name: 'activitylogmodal',
    components: {
        ImageViewer: require('../imageviewer/imageviewer.vue.html').default,
        TodoList,
    }
})
export default class ActivitylogmodalComponent extends Vue {
    @Prop({ required: true })
    readonly modalId!: string;
    @Prop({ required: true })
    readonly duty!: Duty;
    @Prop({ required: true })
    readonly activity!: ActivityLog;
    @Prop({ required: true })
    readonly cells!: Cell[];


    private tab: 1 | 2 = 1;

    formatDateTime = formatDateTime;

    mounted(): void {
    }

    openModal(): void {
        $('#' + this.modalId).modal('show');
        this.tab = 1;
    }

    closeModal(): void {
        $('#' + this.modalId).modal('hide');
    }

    boolenYesNoStr(flag: boolean): string {
        if (flag) {
            return this.$i18n.t('yes').toString();
        } else {
            return this.$i18n.t('no').toString();
        }
    }

    private get todoJson(): string {
        if (this.activity.jsonVMChecklist) { // take the checklist already saved in the activity
            return this.activity.jsonVMChecklist;
        } else {
            if (this.duty.checklists?.length)
                return this.duty.checklists[0].json ?? '[]';
            return '[]';
        }
    }

    //events
    private onComplete(): void {
        this.$toasted.info('Yay. Done!');
        this.closeModal();
    }
}